// @todo: Migrate to 'Skeleton' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Skeleton} from '@material-ui/lab';
import React from 'react';

export const SkeletonCell: React.FC<{height?: number}> = ({height = 26}) => (
  <div className="truncate p-3">
    <Skeleton variant="text" height={height} />
  </div>
);
